@if (data().input_observation) {
<div class="observation-callout vie">
  <mat-icon class="quote-icon">format_quote</mat-icon>
  {{ data().input_observation }}
</div>
}

@if (data().input_transmissionLendemain) {
<div class="demain-block">
  <mat-icon>arrow_forward</mat-icon>
  <div>
    <span class="demain-label">Pour demain</span>
    <p>{{ data().input_transmissionLendemain }}</p>
  </div>
</div>
}
